import { render, staticRenderFns } from "./show-price.vue?vue&type=template&id=41cc752a"
import script from "./show-price.vue?vue&type=script&lang=js"
export * from "./show-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports